import React, { useState, useEffect } from "react";
import ParagraphTag from "../../../reusebale/Paragraph";
import BaseUrl from "../../../../constants/BaseUrl";
import { useSelector } from "react-redux";
import TransactionsList from "../../home/transactionsList";
import db from "../../../../db/index.json";

const TerminationReason = ({ data, reason, amount, leaseId, onViewAllTransactions }) => {
  const { rightPanel } = db;
  const { loginSuccess } = useSelector((state) => state.auth);
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [leaseDetails, setLeaseDetails] = useState(null);

  useEffect(() => {
    if (leaseId) {
      fetchTransactions();
    } else {
      setLoading(false);
    }
  }, [leaseId]);

  const fetchTransactions = async () => {
    try {
      setLoading(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      // Fetch transactions
      const transactionsResponse = await fetch(
        `${BaseUrl}api/payment-transaction/lease/${leaseId}`,
        requestOptions
      );

      const transactionsResult = await transactionsResponse.json();

      if (transactionsResult.status === "success" && transactionsResult.data) {
        // Sort by createdAt descending (newest first)
        const sortedTransactions = transactionsResult.data.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
        setTransactions(sortedTransactions);
      } else {
        setTransactions([]);
      }

      // Fetch lease details to get tenant and property info
      const leaseResponse = await fetch(
        `${BaseUrl}api/lease/getLeaseDetails/${leaseId}`,
        requestOptions
      );
      const leaseResult = await leaseResponse.json();

      if (leaseResult.success) {
        setLeaseDetails(leaseResult.data);
      }
    } catch (error) {
      console.error("Error fetching transactions:", error);
      setTransactions([]);
    } finally {
      setLoading(false);
    }
  };

  const formatCurrency = (amount) => {
    if (!amount) return "$0.00";
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  };

  return (
    <div className="bg-white rounded-xl p-2">
      <div className="px-4 pt-4">
        <ParagraphTag
          content="Lease Terminated"
          classes="text-darkColor font-popinsSemiBold text-lg mt-[-3px]"
        />
      </div>
      <div className="flex mt-1">
        <div className="w-[70%] px-2">
          <div className="pt-3">
            <ParagraphTag
              content="Reason"
              classes="text-darkColor font-popinsSemiBold text-sm"
            />
            <ParagraphTag
              content={`${reason || "N/A"}`}
              classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
            />
          </div>
          <div className="pt-3">
            <ParagraphTag
              content="Refund Amount"
              classes="text-darkColor font-popinsSemiBold text-sm"
            />
            <ParagraphTag
              content={formatCurrency(amount)}
              classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
            />
          </div>
        </div>
      </div>

      {/* Payments Section */}
      <div className="mt-5">
        <div className="bg-white rounded-2xl py-5 px-4 w-full shadow-md shadow-gray-200 transition-all duration-300 hover:opacity-90">
          <div className="flex justify-between items-center ">
            <ParagraphTag
              content="Payments"
              classes="text-darkColor font-popinsSemiBold text-xl"
            />
            {onViewAllTransactions && (
              <ParagraphTag
                content={rightPanel.viewall}
                classes="text-themeColor font-popinsSemiBold text-sm cursor-pointer"
                onTrigger={() => onViewAllTransactions(leaseId)}
              />
            )}
          </div>
          
          <TransactionsList
            transactions={transactions}
            loading={loading}
            leaseDetails={leaseDetails}
            limit={null}
            showHeaders={true}
            showExtendedColumns={false}
          />
        </div>
      </div>
    </div>
  );
};

export default TerminationReason;
